const translation = require('./translation.json');

export default { translation };
